import createIcon from './createIcon';

export default createIcon(require('./phone.svg'));